export type IdentityContext = Readonly<{ epoch: number; accountId?: string }>
export type TransitionOptions = { preserveCsrf?: boolean; preserveClaim?: boolean }
let current: IdentityContext = { epoch: 0 }
const cleanups = new Set<(options: TransitionOptions) => void>()
export function captureIdentity(): IdentityContext { return current }
export function getIdentityEpoch(): number { return current.epoch }
export function isCurrentIdentity(context: IdentityContext): boolean {
  return context.epoch === current.epoch && context.accountId === current.accountId
}
export function assertCurrentIdentity(context: IdentityContext): void {
  if (!isCurrentIdentity(context)) throw new DOMException('Identity changed', 'AbortError')
}
export function registerIdentityCleanup(cleanup: (options: TransitionOptions) => void): () => void {
  cleanups.add(cleanup)
  return () => { cleanups.delete(cleanup) }
}
export function beginIdentityTransition(options: TransitionOptions = {}): IdentityContext {
  current = { epoch: current.epoch + 1 }
  for (const cleanup of cleanups) cleanup(options)
  return current
}
export function completeIdentityTransition(accountId?: string): IdentityContext {
  current = { epoch: current.epoch, ...(accountId ? { accountId } : {}) }
  return current
}
export function identityKey(resource: string, ...params: unknown[]) {
  return ['identity', current.epoch, current.accountId, resource, ...params] as const
}
